import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	titleNonFinal: {
		id: 'periscope.critical-vuln-widget.title-non-final',
		defaultMessage: 'Critical vulnerabilities',
		description: 'The title for the Critical vulnerabilities widget on the Development page.',
	},
});
